import React from 'react';
import { StyledTable, StyledTableContent, StyledTableHeader, StyledTableRow } from '../table/StyledTable';
import { useFormikContext } from 'formik';
import { IWireDepositData } from 'types/order/escrow/IWireDepositData';
import { IncomingDepositRow } from './IncomingDepositRow';

interface IIncomingWireTableProps {
  onDelete: (id: string) => void;
  remove: (index: number) => void;
}
export const IncomingWireTable: React.FC<IIncomingWireTableProps> = ({ onDelete, remove }) => {
  const columns = ['Amount', 'Payer Type', 'Category'];
  const { values, initialValues, setFieldValue } = useFormikContext<{
    wireDeposits: IWireDepositData[];
  }>();
  const { wireDeposits } = values;

  const onCancelEdit = (index: number) => {
    if (initialValues.wireDeposits[index]) {
      setFieldValue(`wireDeposits.${index}`, initialValues.wireDeposits[index]);
    } else {
      remove(index);
    }
  };

  return (
    <StyledTable columnCount={columns.length}>
      <StyledTableHeader>
        <StyledTableRow>
          <div></div>
          {columns.map((t) => (
            <div className={'items-end p-4'} key={t}>
              {t}
            </div>
          ))}
          <div></div>
        </StyledTableRow>
      </StyledTableHeader>
      <StyledTableContent>
        {wireDeposits.map((item, i) => (
          <IncomingDepositRow
            fieldName={'wireDeposits'}
            index={i}
            onCancelEdit={() => onCancelEdit(i)}
            remove={() => remove(i)}
            onDelete={() => onDelete(item.id)}
            newDeposit={!item.createdAt}
            depositData={{ ...wireDeposits[i], depositType: 'Wire' }}
            key={item.id ?? i}
          >
            &nbsp;
          </IncomingDepositRow>
        ))}
      </StyledTableContent>
    </StyledTable>
  );
};
